import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "563.506",
  height: "563.506",
  viewBox: "-181.942 -186.6 563.506 563.506"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "99.811",
      cy: "95.153",
      r: "281.753",
      fill: "none",
      class: "backcircle",
      style: {"stroke":"transparent","stroke-opacity":"0","fill-opacity":"0","fill":"#fff"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M283.326 66.879c-60.736-.089-121.477-.082-182.213.058-4.266.016-8.85.642-12.719 2.298-12.57 5.378-18.593 18.177-16.046 32.637 2.228 12.617 13.745 22.198 28.481 22.649 15.509.466 31.043.12 46.564.132 6.878.004 13.756 0 21.828 0-1.314 3.81-1.637 5.84-2.632 7.453a115 115 0 0 1-2.78 4.27c-14.017 20.424-33.283 32.641-58.933 34.056-7.17.393-13.923-.086-20.28-1.345-19.946-3.978-35.903-15.899-47.727-34.496-19.068-29.978-14.04-67.949 10.995-92.736 24.978-24.717 62.681-28.698 93.04-9.969 3.036 1.874 6.555 4.152 9.876 4.207 22.574.373 45.156.198 69.232.198-1.237-2.811-1.68-4.024-2.267-5.156-26.984-51.273-89.237-79.458-145.825-66.028C-16.305-13.944-58.97 80.476-15.924 160.194c3.402 6.299 1.909 9.487-2.535 13.663-10.082 9.46-20.071 19.044-29.667 28.99-12.563 13.018-12.815 30.825-1.093 42.552 11.63 11.641 29.62 11.256 42.513-1.236 10.172-9.865 20.176-19.912 29.92-30.196.56-.591 1.104-1.1 1.633-1.551 3.452-2.92 6.586-3.033 11.299-.226 16.462 9.779 34.588 15.258 53.621 16.335 66.11 3.736 118.969-32.746 138.869-95.843 1.815-5.766 4.378-7.679 9.009-8.056.754-.063 1.547-.09 2.414-.082 15.506.198 31.086.642 46.529-.502 16.408-1.213 27.015-14.351 26.199-30.214-.793-15.568-12.983-26.93-29.461-26.949",
      class: "logo",
      "paint-order": "stroke",
      style: {"fill-opacity":".9","fill":"#fff"}
    }, null, -1)
  ]))]))
}
export default { render: render }